import useFirestore from "../common/useFirestore";

function useAccountVerifier(){
    const {readFirestoreOneDoc} = useFirestore();

    const accountIdDuplicateVerifier = async(id) => {
        const result = await readFirestoreOneDoc("Account", id).then(res =>{
            return res.exists();
        })
        return result;
    }
    
    const accountFormatValidationHandler = async(inputs, name, value) => {
        let error_description = "";
        switch(name){
            case "name":
                if(value.length < 2){
                    error_description = "이름을 입력해 주세요";
                }
                break;
            case "tel":
                let patternPhone = /^010-?([0-9]{4})-?([0-9]{4})$/;
                if(!patternPhone.test(value)){
                    error_description = "전화번호는 010-0000-0000 형식입니다"
                }
                break;
            case "id":
                if(!value.includes('@')){
                    error_description = "아이디는 반드시 이메일 형식이어야 합니다";
                    break;
                }
                const isDuplicated = await accountIdDuplicateVerifier(value);
                if(isDuplicated){
                    error_description = "이미 사용중인 아이디 입니다";
                }
                break;
            case "password":
                if(value.length < 6){
                    error_description = "비밀번호는 최소 6자리 이상입니다";
                }
                break;
            case "password_re":
                if(inputs.password !== value){
                    error_description = "비밀번호가 일치하지 않습니다";
                }
                break;
        }
        return error_description
    }

    const accountRegisterPreVerifier = (inputs, inputDescriptions) => {
        if(!(inputs.id && inputs.password && inputs.password_re, inputs.name, inputs.tel)){
            return {canLogin:false, description:"데이터를 모두 입력해 주세요"};
        }
        if(inputDescriptions.id || inputDescriptions.password || inputDescriptions.password_re || inputDescriptions.name || inputDescriptions.tel){
            return {canLogin:false, description:"입력한 데이터를 확인해 주세요"};
        }
        return {canLogin:true, description:""};
    }

    return {accountFormatValidationHandler, accountRegisterPreVerifier};
}

export default useAccountVerifier;